import { createContext, useContext, useState } from "react";
import toast from "../utils/toast";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("user");
    return saved ? JSON.parse(saved) : null;
  });

  // Call this after successful login — pass the full `data` object from API
  const login = (data) => {
    // token stored separately so apiClient can read it
    localStorage.setItem("token", data.accessToken);

    // store user info without token
    const { accessToken, ...userInfo } = data;
    localStorage.setItem("user", JSON.stringify(userInfo));
    setUser(userInfo);
  };

   const updateUser = (updatedFields) => {
    setUser((prev) => {
      const updated = { ...prev, ...updatedFields };
      localStorage.setItem("user", JSON.stringify(updated));
      return updated;
    });
  };


  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    toast.success("Logout Successfully !!")
  };

  return (
    <AuthContext.Provider value={{ user, login, logout,updateUser  }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
};